import React, { memo } from 'react';
import classNames from 'classnames';
import { AWStageDto } from '@api/Api';
import { ReactComponent as CalendarSvg } from '@assets/icons/panel-calendar-icon.svg';
import { ReactComponent as ErrorSvg } from '@assets/icons/contributors_limit_error_notification.svg';
import { ReactComponent as CalendarTwoSvg } from '@assets/icons/calendar-v2.svg';
import { useCurrentStage } from '@hooks/useCurrentStage';

type DeadlineCellProps = {
  stages: AWStageDto[];
  currentStageId?: string | null;
  isFinished: boolean;
  isPaused: boolean;
};

export default memo(function DeadlineCell({
  stages,
  currentStageId,
  isPaused,
  isFinished
}: DeadlineCellProps) {
  const { isPastDueDate, formattedDeadline } = useCurrentStage({
    stages,
    currentStageId,
    isFinished,
    isPaused
  });

  return (
    <div
      className={classNames('deadline-cell', {
        'b-has-deadline': !!formattedDeadline,
        'b-date--past': isPastDueDate
      })}
    >
      {!formattedDeadline && (
        <>
          <CalendarTwoSvg />
          No deadline
        </>
      )}
      {!!formattedDeadline && (
        <>
          <CalendarSvg />
          {formattedDeadline}
          {isPastDueDate && (
            <ErrorSvg width={16} height={16} style={{ marginLeft: '4px' }} />
          )}
        </>
      )}
    </div>
  );
});
